import { useQuery } from "@tanstack/react-query";
import { getComponents } from "../../api/Component";
import { IComponent } from "../../typings/Theme";

export const useComponents = () => {
  return useQuery<IComponent[]>(["components"], getComponents);
};
